import React from 'react';
import { servicesData } from '../../data/servicesData';
import ServiceModal from '../../common/serviceModal/ServiceModal';
import { Service } from '../../../types/service';
import YearCarousel from '../../common/yearCarousel/YearCarousel';
import { CarouselImage } from '../../../types/carouselImage';
import './Home.css';

// Import immagini carousel
import image2007 from '../../../assets/images/carousels/2007.jpg';
import image2015 from '../../../assets/images/carousels/2015.jpg';
import image2025 from '../../../assets/images/carousels/2025.jpg';

// Import foto del cliente per homepage
import heroImage from '../../../assets/images/home/hero-profile.jpg';
import aboutImage from '../../../assets/images/home/about-profile.jpg';
import movementImage from '../../../assets/images/home/movement-profile.jpg';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import WelfareBanner from '../../common/welfareBanner/WelfareBanner';

const Home: React.FC = () => {
  const carouselImages: CarouselImage[] = [
    {
      id: '1',
      src: image2007,
      year: '2007',
      alt: 'Aratro 2007',
    },
    {
      id: '2',
      src: image2015,
      year: '2015',
      alt: 'Aratro 2015',
    },
    {
      id: '3',
      src: image2025,
      year: '2025',
      alt: 'Aratro 2025',
    },
  ];
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center min-vh-80 py-5">
            <div className="col-lg-6">
              <div className="hero-content">
                <h1 className="hero-title display-3 fw-bold mb-4">
                  <span className="text-gradient-primary">Stai bene</span>
                  <br />
                  <span className="text-gradient-secondary">
                    Vivi a testa alta
                  </span>
                </h1>
                <p className="hero-description lead text-muted mb-4">
                  Non ci muoviamo più perché invecchiamo o invecchiamo perché
                  non ci muoviamo più?
                </p>
                <div className="hero-actions d-flex gap-3 mb-4">
                  <Link
                    to="/servizi"
                    className="btn btn-secondary btn-lg px-4 py-2"
                  >
                    Scopri i miei servizi
                  </Link>

                  <Link
                    to="/rimettiti-al-centro"
                    className="btn btn-outline-secondary btn-lg px-4 py-2"
                  >
                    Scopri i miei videocorsi
                  </Link>
                </div>
                <div className="hero-features d-flex flex-column gap-2">
                  <div className="feature-item d-flex align-items-center">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-body-emphasis">
                      Consulenze personalizzate
                    </span>
                  </div>
                  <div className="feature-item d-flex align-items-center">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-body-emphasis">
                      Esercizi posturali
                    </span>
                  </div>
                  <div className="feature-item d-flex align-items-center">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-body-emphasis">
                      Yoga e mindfulness
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hero-image position-relative">
                <div className="floating-element element-1 position-absolute"></div>
                <div className="floating-element element-2 position-absolute"></div>
                <div className="floating-element element-3 position-absolute"></div>
                <div className="main-image-placeholder text-center">
                  <img
                    src={heroImage}
                    alt="Annalisa - Formatrice di Benessere Posturale"
                    className="img-fluid rounded-circle shadow-lg"
                    style={{ maxWidth: '400px', border: '8px solid white' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Welfare Banner */}
      <section className="banner-section">
        <div className="container">
          <WelfareBanner />
        </div>
      </section>

      {/* Carousel Section */}
      <section className="carousel-section py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center text-center mb-4">
            <div className="col-12 col-lg-10 col-xl-8">
              <h2 className="section-title display-4 fw-bold mb-3">
                Grazie al benessere posturale
              </h2>
              <p className="section-subtitle lead text-muted mb-5">
                Puoi mantenere la libertà di movimento nonostante lo scorrere
                dei decenni
              </p>
            </div>
          </div>

          {/* Carousel */}
          <div className="row justify-content-center mb-5">
            <div className="col-12">
              <YearCarousel images={carouselImages} />
            </div>
          </div>

          {/* Movement Quote Section */}
          <div className="row justify-content-center mt-5">
            <div className="col-12 col-md-10 col-lg-8">
              <div className="movement-quote text-center p-4 p-lg-5 rounded-3 bg-white shadow-sm border">
                <div className="quote-icon mb-4">
                  <img
                    src={movementImage}
                    alt="Movimento consapevole"
                    className="rounded-circle img-fluid "
                    style={{
                      width: '130px',
                      height: '130px',
                      objectFit: 'cover',
                    }}
                  />
                </div>

                <p className="quote-text fs-2 fw-bold text-dark mb-4 lh-base">
                  "Bastano 30 minuti di movimento al giorno per mantenersi in
                  forma e in buona salute?"
                </p>

                <div className="quote-answer-container p-3 bg-primary bg-opacity-10 rounded">
                  <p className="quote-answer fs-1 fw-bolder  mb-0">
                    DIPENDE DA "COME" TI MUOVI!
                  </p>
                </div>

                <div className="mt-4 text-muted">
                  <small>
                    La qualità del movimento è più importante della quantità
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="about-card card border-0 shadow-sm rounded-3 overflow-hidden">
                <div className="row g-0">
                  {/* Immagine in alto su mobile, a lato su desktop */}
                  <div className="col-md-5">
                    <img
                      src={aboutImage}
                      alt="Annalisa - Formatrice di Benessere"
                      className="img-fluid h-100"
                      style={{ objectFit: 'cover', minHeight: '400px' }}
                    />
                  </div>

                  {/* Contenuto Testuale */}
                  <div className="col-md-7">
                    <div className="card-body p-4 p-lg-5">
                      <div className="about-header mb-4">
                        <h2 className="card-title display-6 fw-bold  mb-2">
                          Ciao, sono Annalisa
                        </h2>
                        <h3 className="card-subtitle h4 text-dark fw-bold mb-3">
                          FORMATRICE DI BENESSERE
                        </h3>
                        <p className="card-text lead text-muted">
                          Ti rivelo le istruzioni per governare la tua postura e
                          <span className="text-success fw-bold">
                            {' '}
                            vivere a testa alta!
                          </span>
                        </p>
                      </div>

                      <div className="about-features">
                        <h4 className="h5 fw-bold text-dark mb-3">
                          Il mio approccio:
                        </h4>
                        <div className="row">
                          <div className="col-12">
                            <ul className="list-unstyled">
                              <li className="d-flex align-items-start mb-2">
                                <i className="bi bi-eye-fill text-success me-2 mt-1"></i>
                                <span>
                                  <strong>Osservazione posturale</strong>{' '}
                                  personalizzata
                                </span>
                              </li>
                              <li className="d-flex align-items-start mb-2">
                                <i className="bi bi-shield-check text-success me-2 mt-1"></i>
                                <span>
                                  <strong>Movimento sicuro</strong> e
                                  consapevole
                                </span>
                              </li>
                              <li className="d-flex align-items-start mb-2">
                                <i className="bi bi-heart-pulse text-success me-2 mt-1"></i>
                                <span>
                                  <strong>Connessione corpo-mente</strong>{' '}
                                  attraverso il respiro
                                </span>
                              </li>
                              <li className="d-flex align-items-start mb-2">
                                <i className="bi bi-lightbulb text-success me-2 mt-1"></i>
                                <span>
                                  <strong>Consapevolezza integrata</strong>:
                                  respiro, intenzione, controllo
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="about-cta mt-4 p-3 bg-primary bg-opacity-10 rounded-2">
                        <p className="mb-0 text-dark fw-semibold">
                          Ti guido nelle{' '}
                          <span className="text-secondary">
                            "istruzioni per l'uso"
                          </span>{' '}
                          del tuo corpo per{' '}
                          <span className="text-success">
                            prevenire danni e vivere meglio!
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section py-5 bg-dark text-white">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title display-4 fw-bold mb-3">
              I miei servizi
            </h2>
            <p className="section-subtitle text-secondary">
              Scopri i percorsi personalizzati per il tuo benessere posturale
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {servicesData.map((service: Service, index: number) => (
              <div
                key={`service-${service.id || index}`}
                className="col-xl-3 col-lg-6 col-md-6"
              >
                <div className="service-card card h-100 border-0 shadow-sm">
                  <div className="service-card-header card-header bg-transparent border-0 text-center pt-4">
                    <div className="service-icon display-4 mb-3 text-primary">
                      <i className={`bi bi-${service.icon || 'star-fill'}`}></i>
                    </div>
                    <h3 className="service-title card-title h5 fw-bold">
                      {service.title}
                    </h3>
                  </div>
                  <div className="service-card-body card-body d-flex flex-column">
                    <p className="service-description card-text text-muted mb-3">
                      {service.shortDesc}
                    </p>
                    <ul className="service-features list-unstyled mb-auto">
                      {service.features?.map((feature, i) => (
                        <li key={i} className="d-flex align-items-center mb-2">
                          <i className="bi bi-check text-success me-2"></i>
                          <span className="text-body-emphasis small">
                            {feature}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="service-card-footer card-footer bg-transparent border-0 text-center pb-4">
                    <button
                      className="btn btn-outline-secondary w-75"
                      data-bs-toggle="modal"
                      data-bs-target={`#serviceModal${index}`}
                      aria-label={`Scopri di più su ${service.title}`}
                    >
                      Scopri di più
                    </button>
                  </div>
                </div>

                <ServiceModal
                  id={index}
                  title={service.title}
                  longDesc={service.longDesc}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section py-5 bg-light">
        <div className="container">
          <div className="cta-content text-center py-4">
            <h2 className="cta-title display-5 fw-bold mb-3">
              Pronto a trasformare la tua postura?
            </h2>
            <p className="cta-description lead text-muted mb-4">
              Inizia oggi il tuo percorso verso un benessere duraturo
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-3">
              <Button
                variant="secondary"
                size="lg"
                className="cta-btn"
                onClick={() =>
                  window.open(
                    'https://wa.me/3757481380',
                    '_blank',
                    'noopener,noreferrer'
                  )
                }
              >
                Prenota una consulenza
              </Button>

              <Button
                variant="outline-secondary"
                size="lg"
                className="cta-btn"
                as="a"
                href="mailto:info@benessereposturale.it"
              >
                Chiedi un preventivo
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
